var _rect, _rect2, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPadrao(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Logo pendente de configuracao",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 212,
    height: 212,
    rx: 40,
    fill: "#F3F4F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 24.5,
    width: 191,
    height: 191,
    rx: 30,
    fill: "none",
    stroke: "#B8BEC7",
    strokeWidth: 3,
    strokeDasharray: "10 9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#9AA1AC",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 74,
    width: 100,
    height: 82,
    rx: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 101,
    r: 9,
    fill: "#9AA1AC",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 146l30-30 20 18 22-24 24 26"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 192,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    letterSpacing: 3,
    fill: "#9AA1AC"
  }, "LOGO")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPadrao);
export default __webpack_public_path__ + "static/media/logo-padrao.7afe4d43ed03103991fb7a926002fd99.svg";
export { ForwardRef as ReactComponent };